
const isOnScreen = function(el){
    if(!el) return false
    const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
}
/**
 * @description 判断元素是否严格在视窗内,被遮挡
 * @param  {HTMLElement} el
 * @return {boolean} is the element in the visual range
 */
export const isOnScreenStrict = function(el){
    if (typeof document.elementsFromPoint !== 'function') return isOnScreen(el)
    el.getBoundingClientRect = el.getBoundingClientRect || (() => ({}));
    const {left, right, top, bottom} = el.getBoundingClientRect();
    const efp = function (p, x, y) {
        const els = document.elementsFromPoint(x, y);
        for (let i = 0; i < els.length; i++) {
            const style = getComputedStyle(els[i]);
            // some masks are transparent and we would ignore
            if (p !== els[i] && (style.opacity < 1 || style.display === 'none' || ['collapse', 'hidden'].indexOf(el.style.visibility) === -1)) {
                continue;
            } else return els[i];
        }
        return els[0];
    };
    if (!isOnScreen(el)) return false;
    return (
        el.contains(efp(el, left, top)) ||
        el.contains(efp(el, right, top)) ||
        el.contains(efp(el, right, bottom)) ||
        el.contains(efp(el, left, bottom))) ||
        el.contains(efp(el, left + (right - left) / 2, top + (bottom - top) / 2));
}

export default isOnScreen